import React from 'react';
import { Link } from 'react-router-dom';
import CssHelper from 'Services/Utils/Css/CssHelper';
import styles from './DropdownItem.module.sass';

const DropdownItem = ({
    children,
    
    href,
    onClick,
    state, border
}: Props) => {
    if (href) {
        return <Link
            to={href}
            className={styles['dropdown__item']}
        >
            { children }
        </Link>
    }

    return <div
        className={CssHelper.createCssClass(`
            ${styles['dropdown__item']}
            ${styles['dropdown__item__state--'+(state||'default')]}
            ${styles['dropdown__item__border--'+(border||'none')]}
        `)}
        onClick={onClick}
        style={{
            cursor: onClick ? 'pointer' : 'auto'
        }}
    >
        { children }
    </div>
}

interface Props {
    children: any
    href?: string
    onClick?: any
    state?: 'danger' | 'default'
    border?: 'top' | 'none'
}

export default React.memo(DropdownItem);